import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProductDetailDto } from 'src/store/products/product';
import styled from 'styled-components';

export type LabelBodyProps = {
  product: ProductDetailDto;
  weight?: string;
};

export const ProductSampleLabelBody: React.FC<LabelBodyProps> = ({
  product,
  weight
}) => {
  const { t } = useTranslation();

  return (
    <StyledWrapper>
      <p>
        <span>{product.grade.name}</span>
      </p>

      {product.lotNo && (
        <p>
          <label>{t('product.lotNo')}:</label>
          <span>{product.lotNo}</span>
        </p>
      )}

      <p>
        <label>{'Weight'}:</label>
        <span>{weight || '-'}</span>
      </p>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  p {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;

    label {
      display: inline-block;
      width: 60px;
      white-space: nowrap;
    }

    span {
      font-weight: bold;
    }
  }
`;
